import { Link } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const SHOW_WITHIN_DAYS = 7;

export const RenewalNotice = () => {
  const { user } = useAuth();
  if (!user?.is_member || !user.member_until) return null;
  const end = new Date(user.member_until);
  const daysLeft = Math.ceil((end - Date.now()) / 86400000);
  if (daysLeft > SHOW_WITHIN_DAYS) return null;
  const endLabel = end.toLocaleDateString(undefined, { month: "long", day: "numeric" });

  return (
    <div className="border border-accent bg-accent/5 p-5 sm:p-6 mb-8 flex flex-col sm:flex-row sm:items-center gap-4 justify-between" data-testid="renewal-notice">
      <div className="flex items-start gap-3">
        <CalendarClock className="h-5 w-5 text-accent shrink-0 mt-0.5" />
        <div>
          <div className="font-serif text-lg sm:text-xl leading-snug" data-testid="renewal-notice-text">
            Your Shift+ month ends {endLabel}
            {daysLeft > 0 ? ` — ${daysLeft} day${daysLeft === 1 ? "" : "s"} left.` : "."}
          </div>
          <p className="text-sm text-muted-foreground mt-1">Renew for $33 to keep your access for another 30 days. Time left carries over.</p>
        </div>
      </div>
      <Link to="/membership?plan=shift_society" data-testid="renewal-notice-renew-link">
        <Button className="w-full sm:w-auto btn-pill font-mono uppercase text-xs tracking-widest h-11 px-6 gap-2">
          Renew Shift+ <ArrowRight className="h-4 w-4" />
        </Button>
      </Link>
    </div>
  );
};
